/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { Button, Col, Form, Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';

const SectionEditForm = ({
  handleEditMode,
  currentSection,
  currentCode,
  busy,
  busyLabel,
  handleSave,
}) => {
  const [title, setTitle] = useState(currentSection || '');
  const [code, setCode] = useState(currentCode || '');
  const onSave = () => {
    handleSave({
      title,
      code,
    });
  };
  return (
    <Col md="3" className="p-3 survey-sidebar edit-mode position-relative">
      {busy && (
        <div className="editor-loading-overlay">
          <Spinner animation="border" role="status" />
          {busyLabel}
        </div>
      )}
      <span
        className="d-flex"
        onClick={handleEditMode}
        onKeyDown={handleEditMode}
        role="button"
        tabIndex={0}
      >
        <FontAwesomeIcon size="sm" className="mr-3" icon={faChevronLeft} />
        Back to overview
      </span>
      <Col className="info-edit-form">
        <div>
          <h4>Section Name</h4>
          <Form.Control
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Section Name"
            type="text"
            maxLength={75}
            value={title}
          />
          <span className="hint">Character Limit: 75</span>
        </div>
        <div className="d-none">
          <h4>Section Code</h4>
          <Form.Control
            onChange={(e) => setCode(e.target.value)}
            placeholder="Section Code"
            type="text"
            maxLength={3}
            value={code}
          />
          <span className="hint">Character Limit: 3</span>
        </div>
      </Col>
      <Button variant="primary" onClick={onSave} disabled={busy} className="btn btn-custom dark">
        Save
      </Button>
    </Col>
  );
};

SectionEditForm.propTypes = {
  currentSection: PropTypes.string.isRequired,
  currentCode: PropTypes.string,
  busy: PropTypes.bool,
  busyLabel: PropTypes.string,
  handleEditMode: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
};

export default SectionEditForm;
